import { createFormData } from 'Utils/deepParseJson'
import BaseService from './BaseService'

const ApiService = {
    get(url, params, config = {}) {
        return BaseService({
            method: 'GET',
            url,
            params,
            ...config,
        })
    },
    post(url, data, options = {}) {
        return BaseService({
            method: 'POST',
            url,
            data: createFormData(data),
            ...options,
        })
    },
    patch(url, data) {
        return BaseService({
            method: 'PATCH',
            url,
            data: createFormData(data),
        })
    },
    update(url, slug, data) {
        return BaseService({
            method: 'PUT',
            url: `${url}/${slug}`,
            data: createFormData(data),
        })
    },
    put(url, data) {
        return BaseService({
            method: 'PUT',
            url,
            data: createFormData(data),
        })
    },
    destroy(url) {
        return BaseService({
            method: 'DELETE',
            url,
        })
    },
    blob(url) {
        return BaseService.get(url, {
            responseType: 'blob',
        })
    },
}

export default ApiService
